import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./components/dashboard/dashboard').then(m => m.Dashboard),
        canActivate: [MsalGuard]
    },
    {
        path: 'admin',
        redirectTo: 'workbench',
        pathMatch: 'full'
    },
    {
        path: 'workbench',
        loadComponent: () => import('./workbench/workbench').then(m => m.Workbench),
        canActivate: [MsalGuard],
        children: [
            { path: '', redirectTo: 'summary', pathMatch: 'full' },
            {
                path: 'reference',
                loadComponent: () => import('./workbench/reference-data/reference-data').then(m => m.ReferenceData)
            },
            {
                path: 'summary',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./workbench/summary/summary-list/summary-list').then(m => m.SummaryList)
                    },
                    {
                        path: 'new',
                        loadComponent: () => import('./workbench/summary/summary-builder/summary-builder').then(m => m.SummaryBuilder)
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./workbench/summary/summary-view-detail/summary-view-detail').then(m => m.SummaryViewDetail)
                    },
                    {
                        path: ':id/edit',
                        loadComponent: () => import('./workbench/summary/summary-builder/summary-builder').then(m => m.SummaryBuilder)
                    }
                ]
            },
            {
                path: 'initiatives',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./workbench/initiatives/initiatives').then(m => m.Initiatives)
                    },
                    {
                        path: 'new',
                        loadComponent: () => import('./workbench/initiatives/initiative-onboard/initiative-onboard').then(m => m.InitiativeOnboard)
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./workbench/initiatives/initiative-detail/initiative-detail').then(m => m.InitiativeDetail)
                    }
                ]
            },
            {
                path: 'data-sets',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./workbench/data-sets/data-sets').then(m => m.DataSets)
                    },
                    {
                        path: 'new',
                        loadComponent: () => import('./workbench/data-sets/data-set-new/data-set-new').then(m => m.DataSetNew),
                        data: { kind: 'table' }
                    },
                    {
                        path: 'raw/:id',
                        loadComponent: () => import('./workbench/data-sets/raw-dataset/raw-dataset-view').then(m => m.RawDatasetView)
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./workbench/data-sets/data-set-detail/data-set-detail').then(m => m.DataSetDetail)
                    }
                ]
            },
            {
                path: 'assumptions',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./workbench/assumptions/assumptions').then(m => m.Assumptions)
                    },
                    {
                        path: 'new',
                        loadComponent: () => import('./workbench/assumptions/assumption-set-new/assumption-set-new').then(m => m.AssumptionSetNew),
                        data: { kind: 'assumptions' }
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./workbench/assumptions/assumption-set-detail/assumption-set-detail').then(m => m.AssumptionSetDetail)
                    }
                ]
            },
            {
                path: 'metrics',
                loadComponent: () => import('./workbench/metrics/metrics').then(m => m.Metrics)
            },
            {
                path: 'formulas',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./workbench/formulas/formulas').then(m => m.Formulas)
                    },
                    {
                        path: 'new',
                        loadComponent: () => import('./workbench/formulas/formula-new/formula-new').then(m => m.FormulaNew)
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./workbench/formulas/formula-new/formula-new').then(m => m.FormulaNew)
                    }
                ]
            },
            {
                path: 'formula-history',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./workbench/formula-history-page/formula-history-page').then(m => m.FormulaHistoryPage)
                    },
                    {
                        path: ':executionId',
                        loadComponent: () => import('./workbench/formula-history-page/formula-history-detail').then(m => m.FormulaHistoryDetail)
                    }
                ]
            }
        ]
    },
    {
        path: 'logout',
        loadComponent: () => import('./core/auth/pages/logout/logout').then(m => m.Logout)
    },
    {
        path: 'unauthorized',
        loadComponent: () => import('./core/auth/pages/unauthorized/unauthorized').then(m => m.Unauthorized)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
